/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import fetchHelper from "../../services/fetchHelper";
import "./InterrogationOrders.scss";
import { LayoutContext } from "../../components/layout";
import { convertUTCDateToLocalDate } from "../../utils/helpers";

const filterTableData = (data) => data.filter((item) => item.visitStr1 && item.visitStr1.trim());

const InterrogationOrders = () => {
  const { setIntrOrderInfo } = useContext(LayoutContext);
  const { i } = useParams();
  const [data, setData] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const updateIR = (item) => {
    setIntrOrderInfo({ irId: item?.id, irVisitNumber: item?.visitStr1, irDate: item?.orderDate });
  };

  const fetchData = async () => {
    try {
      const urlParams = {
        where: JSON.stringify({ "patient.id": { $eq: i } }),
        sort: "-orderDate",
      };

      const urlSearch = new URLSearchParams(urlParams);

      const data = await fetchHelper.get({
        url: "/patientmanagement/rest/interrogationorders?" + urlSearch,
      });
      setData(filterTableData(data));
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="tabContent insurance-information">
      <div className="content">
        <div className="grpHdrPg">
          <h3>
            Patient Profile: <span>John Smith</span>
          </h3>
        </div>
        <div className="grpHdr">
          <h3>Interrogation Orders</h3>
        </div>
        <div className="contentTbl">
          <table className="overview" id="data-table">
            <thead>
              <tr>
                <th className="hideBs" />
                <th>Visit #</th>
                <th>Visit # - Secondary</th>
                <th>Dept</th>
                <th>Order#</th>
                <th>Date</th>
                <th>Procedure Code</th>
                <th>IR</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item) => (
                <tr key={item.id}>
                  <td>{item.visitStr1}</td>
                  <td>{item.visitStr2}</td>
                  <td>{item.department}</td>
                  <td>{item.orderNo}</td>
                  <td>{convertUTCDateToLocalDate(item.orderDate, "DATE_SHORT")}</td>
                  <td>{item.procedureCode}</td>
                  <td className="alignCenter showBs">
                    {item.interrogation ? (
                      <a href={`/dashboard3/${item.interrogation.id}`}>
                        <button className="btn btnSm btnTealL fullWidth">View Report</button>
                      </a>
                    ) : (
                      <div className="createIR-report-button">
                        <a href="#popupIR" onClick={() => updateIR(item)}>
                          <button className="btn btnSm btnTealL fullWidth" data-testid="create-ir-button">
                            <i className="ti ti-plus intOrder"></i>Create IR
                          </button>
                        </a>
                        <a id="upload-report-btn" href="#uploadIR" onClick={() => updateIR(item)}>
                          <button className="btn btnSm btnTealL fullWidth">
                            <i className="ti ti-plus intOrder"></i>Upload IR
                          </button>
                        </a>
                      </div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default InterrogationOrders;
